// removed by extract-text-webpack-plugin
module.exports = {"sortbox":"_3HMERY562dq4vQifht7HgU","hideicons":"_3wO8lp3tPga-NQJ1NwNkxT","hideiconsplus":"_1lrCcgBe-U6M0MAtWojzCN","hideiconstrash":"_31M7hEKkK9CnMLXRQdtAjb","icon_wrapper":"zueyP1ZTaVVp1La9skdNk","hover":"_28LQEHbzuAljAgAEAH2cZH","movehandleout":"_19dD3Ccq4rIEIvmpZIkq9V","movehandleupout":"T3gK0cDdI1qHC_f08P30p","movehandledownout":"_3C8RMaOl9Whb-CBs7GfwHP","movehandle":"_2E2zC3KnfFxq7SP3jczt52","sortableItemParent":"_1MwQfXRxyN2hjM-7rxQH-d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sortable/Sortable.scss
// module id = 1093
// module chunks = 0